import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { withTranslation } from 'react-i18next';

class ReportsAGGrid extends Component {
    render() {
        const {
            columnDefs,
            rowData,
            sideBar,
            suppressMenuHide,
            onGridReady,
            defaultColDef,
            onPaginationChanged,
            rowHeight,
            getRowId,
            onFirstDataRendered,
            onModelUpdated,
            onRowSelected
        } = this.props;

        return (
            <div className="ag-theme-alpine" style={{ boxSizing: "border-box", width: "100%" }}>
                <AgGridReact
                    rowModelType='serverSide'
                    rowSelection='multiple'
                    columnDefs={columnDefs}
                    rowData={rowData}
                    sideBar={sideBar}
                    suppressMenuHide={suppressMenuHide}
                    onGridReady={onGridReady}
                    enableSorting={true}
                    enableFilter={true}
                    floatingFilter={true}
                    enableColResize={true}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    paginationPageSize={25}
                    domLayout='autoHeight'
                    onPaginationChanged={onPaginationChanged}
                    cacheBlockSize={25}
                    rowHeight={rowHeight} // default: 25px
                    getRowId={getRowId}
                    onFirstDataRendered={onFirstDataRendered}
                    onModelUpdated={onModelUpdated}
                    onRowSelected={onRowSelected}
                />
            </div>
        );
    }
}

export default (withTranslation()(ReportsAGGrid));


// WEBPACK FOOTER //
// ./src/components/reports/reportsGrid/reportsAGGrid.js